import { createSlice } from "@reduxjs/toolkit";

export const DashboardInitialState = {
  mostRepeatedReference: [],
  achats: [],
  topEcartAttribution: [],
  lastInventoryId: "",
  ecartInventoryParRapportInventory: [],
  ecartInventoryDifference: [],
  stockQuantity:0,
  stockValorisation:0
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: DashboardInitialState,
  reducers: {
    setMostRepeatedReference: (state, action) => {
      state.mostRepeatedReference = action.payload.mostRepeatedReference;
    },
    setAchats: (state, action) => {
      state.achats = action.payload.achats;
    },
    setTopEcartAttribution: (state, action) => {
      state.topEcartAttribution = action.payload.topEcartAttribution;
    },

    setLastInventoryId: (state, action) => {
      state.lastInventoryId = action.payload.lastInventoryId;
    },
    setEcartInventoryParRapportInventory: (state, action) => {
      state.ecartInventoryParRapportInventory =
        action.payload.ecartInventoryParRapportInventory;
    },
    setEcartInventoryDifference: (state, action) => {
      state.ecartInventoryDifference = action.payload.ecartInventoryDifference;
    },
    setStockQuantity: (state, action) => {
      state.stockQuantity = action.payload.stockQuantity;
    },
    setStockValorisation: (state, action) => {
      state.stockValorisation = action.payload.stockValorisation;
    },

  },
});

export const {
  setMostRepeatedReference,
  setAchats,
  setTopEcartAttribution,
  setLastInventoryId,
  setEcartInventoryParRapportInventory,
  setEcartInventoryDifference,
  setStockQuantity,
  setStockValorisation
} = dashboardSlice.actions;
